module.exports = __webpack_public_path__ + "img/packages/laptop.009567.png";